/**
 * Genera las opciones de años para dropdowns
 * Retorna el año actual y el año anterior
 * @returns {Array} Array de objetos con value y label
 */
export function getYearOptions() {
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;

  // Formato de 2 dígitos (ej: 24, 25)
  const currentYearShort = currentYear.toString().slice(-2);
  const previousYearShort = previousYear.toString().slice(-2);

  return [
    { value: previousYearShort, label: previousYearShort },
    { value: currentYearShort, label: currentYearShort },
  ];
}

/**
 * Genera las opciones de años con formato completo
 * @returns {Array} Array de objetos con value y label en formato completo
 */
export function getYearOptionsFullFormat() {
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;

  return [
    { value: previousYear.toString(), label: previousYear.toString() },
    { value: currentYear.toString(), label: currentYear.toString() },
  ];
}
